import { TButtonSize, TButtonVariant } from "./button.models";

export const BUTTON_BASE_CLASS =
  "inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-colors " +
  "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500 " +
  "disabled:cursor-not-allowed disabled:opacity-60";

export const BUTTON_VARIANT_CLASS: Record<TButtonVariant, string> = {
  primary: "bg-brand-600 text-white hover:bg-brand-700",
  secondary:
    "bg-white text-ink-900 ring-1 ring-inset ring-ink-900/12 hover:bg-surface-muted",
  ghost: "text-ink-700 hover:bg-surface-muted hover:text-ink-900",
};

export const BUTTON_SIZE_CLASS: Record<TButtonSize, string> = {
  sm: "h-9 px-3 text-sm",
  md: "h-11 px-5 text-sm",
  lg: "h-12 px-6 text-base",
};
